<template>
    <div class="index-input">
        <div class="index-input-div" v-if="formDataInfo.data_collects.length>0">
            <el-form labelPosition="top" ref="dataForm">
                <el-row class="columnboxAbout" :gutter="$store.state.isPC?20:0">

                    <el-col :span="showClass(item.type)" v-for="(item,index) in formDataInfo.data_collects" :key="'input_'+index">
                    <!-- type  1文本 2密码 3手机号 4邮箱 5日期 6时间 7文本框 8图片 9描述 10单选 11多选 12电子签名 13输入框 14按钮 -->
                        <template v-if="item.type==1 || item.type==2 || item.type==4">
                                <!-- :label="item.title" -->
                            <el-form-item
                                :rules="[
                                  { required: item.is_require == 1 ? true:false, message: '请输入'+item.title},
                                  { type: item.type==4?'email':'', message: item.type==4?'请输入正确的邮箱地址':''}
                                ]"
                              >
                                <el-input :type="item.type==2?'password':'text'" v-model="item.content" autocomplete="off" :placeholder="item.title"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="item.type==3">
                            <el-form-item
                                :rules="[
                                  { required: item.is_require == 1 ? true:false, message: '请输入'+item.title}
                                ]"
                              >
                                <el-input type="number" v-model="item.content" autocomplete="off" :placeholder="item.title"></el-input>
                            </el-form-item>
                            <div class="fcb">
                                <el-input
                                    v-model="verify_code"
                                    center
                                    :validate-event="true"
                                    label="验证码"
                                    placeholder="请输入验证码"
                                />&nbsp;&nbsp;
                                <div slot="append" @click="refreshCode"><Identify :identifyCode="identifyCode"></Identify></div>
                            </div>
                        </template>

                        <template v-if="item.type==5">
                            <el-date-picker
                              v-model="item.content"
                              :label="item.title"
                              :name="item.title"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="YYYY-MM-DD">
                            </el-date-picker>
                        </template>
                        <template v-if="item.type==6">
                            <el-time-select
                              v-model="item.content"
                              :label="item.title"
                              right-icon="arrow"
                              :name="item.title"
                              :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '23:59'
                              }"
                              placeholder="hh:ss">
                            </el-time-select>
                        </template>

                        <!-- 7文本框 -->
                        <template v-if="item.type==7">

                            <el-form-item
                                :rules="[
                                  { required: item.is_require == 1 ? true:false, message: '请输入'+item.title}
                                ]"
                              >
                                <el-input type="textarea" rows="4" v-model="item.content" autocomplete="off" :placeholder="item.title"></el-input>
                            </el-form-item>
                        </template>
                        <!-- 8图片 -->
                        <template v-if="item.type==8">
                            <div @click="uploadClickImg(index)" class="fcb">
                                <div>{{item.title}}</div>
                                <el-image
                                    v-if="item.content"
                                    width="50"
                                    height="50"
                                    :src="item.content"
                                />
                                <el-image
                                    v-else
                                    width="50"
                                    height="50"
                                    fit="contain"
                                    :src="require('@/assets/img/image.png')"
                                />
                            </div>
                        </template>
                        <!-- 9文字描述 -->
                        <template v-if="item.type==9">
                            <div style="text-align: left;font-weight: bold;margin:10px 0;">{{item.title}}</div>
                        </template>
                        <!-- 10單選框 -->
                        <template v-if="item.type==10">
                            <div class="fcb">
                                <div>{{item.title}}</div>
                                <div>
                                    <el-radio v-model="item.content" v-for="(radio,index) in item.value" :key="'radio_'+index" :label="radio.title">{{radio.title}}</el-radio>
                                </div>
                            </div>                            
                        </template>
                        <!-- 11多選框 -->
                        <template v-if="item.type==11">
                            <div class="fcb">
                                <div>{{item.title}}</div>
                                <div>
                                    <el-checkbox-group v-model="item.content">
                                        <el-checkbox v-for="(checkbox,index) in item.value" :key="'checkbox_'+index" :label="checkbox.title"></el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </template>

                        <template v-if="item.type==12">
                            <div class="tl">{{item.title}}</div>
                            <vue-esign :ref="'esign_'+index" :width="1200" :height="300" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" style="border: 1px solid #666;"/>
                            <div class="tr">
                                <div class="esignBtn" @click="handleReset(index);">清空画板</div>
                                <div class="esignBtn" @click="handleGenerate(index);">生成图片</div>
                            </div>
                        </template>

                        <template v-if="item.type==13">
                            <div class="tl">
                                <span style="font-weight: bold;">{{item.title}}</span>
                                <el-button class="esignBtn" native-type="button" @click="addInput(index);">添加</el-button>
                            </div>
                            <div class="cell-input" v-for="(input,n) in item.content" :key="'input_'+n">
                                    <!-- :label="inputItem.title" -->
                                <el-form-item
                                    v-for="(inputItem,i) in input"
                                    :key="'inputItem_'+i"
                                    :rules="{ required: item.is_require == 1 ? true:false, message: '请输入'+inputItem.title }"
                                  >
                                    <el-input v-model="inputItem.value" :placeholder="inputItem.title"></el-input>
                                    <el-button v-if="n!=0&&i==input.length-1" @click.prevent="delInput(index, n)">删除</el-button>
                                </el-form-item>
                            </div>
                        </template>

                        <template v-if="item.type==14">
                            <div style="margin: 16px;text-align: center;">
                                <el-button round block type="info" @click="verifyCode">{{item.title}}</el-button>
                            </div>
                        </template>

                    </el-col>
                </el-row>
            </el-form>

            <!-- 簽名彈框 -->
            <el-dialog 
                v-model="signatureShow"
                title="簽名"
                show-cancel-button
                width="80%"
                @confirm="signatureConfirm"
                @cancel="signatureCancel"
                @close="signatureClose"
            >
                <div style="width:100%;height:400px">
                    <vue-esign
                        ref="esign"
                    />
                </div>
            </el-dialog>

            <input type="file" name="avatar" id="uppic" accept="image/gif,image/jpeg,image/jpg,image/png" @change="changeImage" ref="imgInput" style="opacity: 0;width: 0;height: 0;padding: 0;display: inherit;">
        </div>
    </div>
</template>
<script>
import Identify from '@/mode/identify'
export default {
    components: {
        Identify,
    },
    name:'inputMode',
    props:{
        formData:{
            type:Object,
        },
    },
    data () {
        const validateCode = (rule, value, callback) => {
          if (this.identifyCode !== value) {
            this.loginForm.code = ''
            this.refreshCode()
            callback(new Error('请输入正确的验证码'))
          } else {
            callback()
          }
        }
        return {
            formDataInfo: this.formData,
            isShowPicker: false,
            currentContent: '',
            pickerTpye: '',
            checkIndex: '',
            fileList:[],
            checkUploadIndex: '',
            uploadImg: '',//测试图
            minDate:new Date(1950, 0, 1),
            maxDate:new Date(),

            signatureShow: false, // 簽名彈框
            vueEsignImg: '', // 簽名圖片base64

            lineWidth: 6,   //签名框
            lineColor: '#000000',
            bgColor: '#fff',
            isCrop: false,

            identifyCodes: '1234567890',
            identifyCode: '',//找回密码图形验证码
            verify_code: '', //输入的验证码

        }
    },
    computed:{
        showClass(){
            return function(type){
                if(type == 7 || type == 9 || type == 12 || type == 14){
                    return 24;
                }else{
                    if(this.formDataInfo.layout == 1){
                        return 24;
                    }else if(this.formDataInfo.layout == 2){
                        return this.$store.state.isPC?12:24;
                    }else if(this.formDataInfo.layout == 3){
                        return this.$store.state.isPC?8:24;
                    }else if(this.formDataInfo.layout == 4){
                        return this.$store.state.isPC?6:12;
                    }else if(this.formDataInfo.layout == 5){
                        return this.$store.state.isPC?5:12;
                    }
                }
            }
        },
    },
    watch: {
        identifyCode(v) {
            this.isDebugLogin && (this.loginForm.code = v)
        },
    },
    mounted(){
        let isHasPhone = false;
        if(this.formDataInfo.data_collects.length>0){
            this.formDataInfo.data_collects.forEach((item,i) => {
                let data = {};
                if(item.type == 3){
                    isHasPhone = true;
                }else if(item.type == 11){
                    item.content = [];
                }else if(item.type == 13){
                    let inputList = [];
                    for(let key in item.value){
                        let inputitem = {title:item.value[key].title,value:''};
                        inputList.push(inputitem)
                    }
                    item.content = [inputList];
                }
            })
        }
        if(isHasPhone){this.makeCode(this.identifyCodes, 4);}
    },
    created(){
    },
    methods:{
        randomNum(min, max) {
          return Math.floor(Math.random() * (max - min) + min)
        },
        refreshCode() {
          this.identifyCode = ''
          this.makeCode(this.identifyCodes, 4)
        },
        makeCode(o, l) {
          for (let i = 0; i < l; i++) {
            this.identifyCode += this.identifyCodes[
              this.randomNum(0, this.identifyCodes.length)
              ]
          }
        },
        onConfirm(value,index) {
            this.areaCode[index] = value;
            this.showPicker = false;
        },
        onSubmit(){
            let content = [];
            this.formDataInfo.data_collects.forEach((item,i) => {
                if(item.type == 14){
                    
                }else{
                    let data = {};
                    data = {
                        title: item.title,
                        value: item.content,
                    };
                    content.push(data);
                }
            })
            // console.log(content);
            this.$axios({
                method: 'POST',
                url:'/api/collect',
                data:{
                    page_id:this.$route.params.page_id,
                    module_id:this.formDataInfo.page_module_relation_id,
                    content: JSON.stringify(content),
                },
            }).then(res => {
                console.log(res);
                if(res){
                    console.log(this.pageContent);
                    this.$message.success('提交成功')
                }else{
                    this.$message({
                        message:res.data.message,
                        type: 'fail',
                        duration:1800,
                        offset:200
                    });
                }
            }).catch(error=>{

            });
        },
        // 校验函数返回 true 表示校验通过，false 表示不通过
        validatorEmail(val) {
            return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val)
        },
        formatDateYMD(value){
            if (!value){ 
                return '';
            }else{
                var date = new Date(value);
                var Y = date.getFullYear()+'-';
                var M = (date.getMonth()+1)+ '-';
                var D = date.getDate();
                return Y+M+D;
            }
        },
        uploadClickImg(index){
            this.checkUploadIndex = index;
            this.$refs['imgInput'].click();
        },
        changeImage(){
            var file = this.$refs['imgInput'].files[0];
            console.log(this.$refs.imgInput);
            console.log(file);
            var reader = new FileReader();
            let self = this;
            reader.readAsDataURL(file)
            reader.onload = function(e) {
                // self.formData.data_collects[self.checkUploadIndex].content = this.result;
                let formData = new FormData();
                formData.append('image', file) // 要提交给后台的文件
                formData.append('type', 'collect');
                console.log(formData);
                self.$axios({
                    method: 'POST',
                    url: '/api/upload/images',
                    data:formData,
                }).then(res => {
                    console.log(res);
                    self.formData.data_collects[self.checkUploadIndex].content = res.path;
                }).catch(err => {
                    self.$message({
                        message:'上传图片失败',
                        type: 'fail',
                        duration:1800,
                        offset:200
                    });
                });
            }
        },
        handleReset(index) {
            this.$refs['esign_'+index][0].reset() //清空画布
        },
        handleGenerate(index) {
            var self = this;
            this.$refs['esign_'+index][0].generate().then(res => {
                // let resultImg = res // 得到了签字生成的base64图片
                // console.log(res);
                self.$axios({
                    method: 'POST',
                    url: '/api/upload/autograph',
                    data:{
                        image: res,
                        path:'',
                    },
                }).then(res => {
                    console.log(res);
                    self.formDataInfo.data_collects[index].content = res.path;
                }).catch(err => {
                    self.$message({
                        message:'上传图片失败',
                        type: 'fail',
                        duration:1800,
                        offset:200
                    });
                });
            }).catch(err => { //  没有签名，点击生成图片时调用
                self.$message({
                    message:err + ' 未签名！',
                    type: 'fail',
                    duration:1800,
                    offset:200
                });
                alert(err) // 画布没有签字时会执行这里 'Not Signned'
            })
        },
        // 添加输入框
        addInput(index){
            const content = this.formDataInfo.data_collects[index].content;
            let newContent = [];
            content[0].forEach(item=>{
                var it = {
                    title: item.title,
                    value: ''
                };
                newContent.push(it);
            })
            let len = this.formDataInfo.data_collects[index].content.length;
            this.$set(this.formDataInfo.data_collects[index].content,len,newContent)
        },
        // 删除输入框
        delInput(index,n) {
            let content = this.formDataInfo.data_collects[index].content;
            content.splice(n,1)
        },
        // 验证验证码
        verifyCode(){
            let content = [];
            if(this.verify_code == this.identifyCode){
                const vm=this;
                this.formDataInfo.data_collects.forEach((item,i) => {
                    if(item.type == 14){
                        
                    }else{
                        let data = {};
                        data = {
                            title: item.title,
                            value: item.content,
                        };
                        content.push(data);
                    }
                })
                console.log(content);
                setTimeout(function(){
                    vm.onSubmit();
                },600);
            }else{
                this.$message({
                    message:'验证码错误',
                    type: 'fail',
                    duration:1800,
                    offset:200
                });
            }
        },
        signatureConfirm() {
            this.$refs.esign.generate().then(res => {
                console.log(res);
                this.vueEsignImg = res
            }).catch(err => {
                console.log(err);
            })
        },
        signatureCancel() {
            this.$refs.esign.reset()
        },
        signatureClose() {
            this.$refs.esign.reset()
        }
    },
}
</script>
<style scoped>
/* 输入框模块 */
/deep/ .el-col-5{width:20%;}
.columnboxAbout {width:100%;}
.textContent >div{overflow: hidden;}
.SMSconfirm{
    color: #fff;
    border: none;
    outline: none;
    background-color: #2f75f4;
    font-size: 16px;
    border-radius: 13px;
}
.esignBtn{color: #fff;border: none;outline: none;background-color: #2f75f4;font-size: 16px;border-radius: 13px;height: 35px;line-height: 35px;margin: 10px 0 10px 10px;display: inline-block;width: auto;padding: 0 10px;cursor: pointer;}
.esignDelBtn{color: #fff;border: none;outline: none;background-color: #dd4b39;font-size: 16px;border-radius: 13px;height: 35px;line-height: 35px;margin: 10px 0 10px 10px;}
.index-input-div {
    width: 90%;
    margin: auto;
}
.cell-input{margin-bottom: 20px; }
/deep/ .el-radio__icon, /deep/ .el-radio__icon .el-icon, /deep/ .el-checkbox__icon, /deep/ .el-checkbox__icon .el-icon{
    font-size: 18px;height: 20px;line-height: 20px;
}
/deep/ .el-input--suffix .el-input__inner{padding-left: 30px;}
</style>


// WEBPACK FOOTER //
// src/mode/inputMode.vue